import {DHSurveyData} from "../types/DHSurveyData";
import {StagingTitelineAppDHSurvey} from "../types/StagingTitelineAppDHSurvey";
import { getApiUrl } from '../config/api';

export const fetchDHSurveyByPid = async (pid: number, aid: number = -1): Promise<DHSurveyData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineDHSurvey/GetDHSurveyByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            console.log("Failed to fetch dh-survey data by pid:", pid, "state:", response.status, response.statusText);
            return [];
        }

        let backendData: StagingTitelineAppDHSurvey[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((dh_survey) => dh_survey.DataSource === aid.toString());
        }

        const transformedData: DHSurveyData[] = backendData.map((dhSurvey) => ({
            key: dhSurvey.DhsId,
            dhs_id: dhSurvey.DhsId,
            pid: dhSurvey.Pid,
            hole_id: dhSurvey.HoleID,
            depth: dhSurvey.Depth,
            tool_type: dhSurvey.ToolType,
            tool_no: dhSurvey.ToolNo,
            dip: dhSurvey.Dip,
            azimuth: dhSurvey.Azimuth,
            azi_type: dhSurvey.AziType,
            mag_int: dhSurvey.MagInt,
            mag_dip: dhSurvey.MagDip,
            grav_roll: dhSurvey.GravRoll,
            temp: dhSurvey.Temp,
        }));

        return transformedData;
    } catch (error) {
        console.error("Error in fetchDrillingByPid API call:", error);
        return [];
    }
};

export const addDHSurveyRow = async (dhSurveyRow: DHSurveyData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineDHSurvey/AddDHSurvey');

    const cloudPayload = [
        {
            Pid: dhSurveyRow.pid ?? -1,
            HoleID: dhSurveyRow.hole_id,
            Depth: dhSurveyRow.depth,
            ToolType: dhSurveyRow.tool_type,
            ToolNo: dhSurveyRow.tool_no,
            Dip: dhSurveyRow.dip,
            Azimuth: dhSurveyRow.azimuth,
            AziType: dhSurveyRow.azi_type,
            MagInt: dhSurveyRow.mag_int,
            MagDip: dhSurveyRow.mag_dip,
            GravRoll: dhSurveyRow.grav_roll,
            Temp: dhSurveyRow.temp,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("DH Survey row added to cloud successfully.");
            return true;
        } else {
            console.error("Failed to add DH Survey row to cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in addDHSurveyRow API call:", error);
        return false;
    }
};

export const updateDHSurveyRow = async (dhs_id: number, updatedRow: DHSurveyData) => {
    const apiUrl = getApiUrl(`/api/TitelineDHSurvey/UpdateDHSurveyByDhsid/${dhs_id}`);

    const cloudPayload = {
        HoleID: updatedRow.hole_id,
        Depth: updatedRow.depth,
        ToolType: updatedRow.tool_type,
        ToolNo: updatedRow.tool_no,
        Dip: updatedRow.dip,
        Azimuth: updatedRow.azimuth,
        AziType: updatedRow.azi_type,
        MagInt: updatedRow.mag_int,
        MagDip: updatedRow.mag_dip,
        GravRoll: updatedRow.grav_roll,
        Temp: updatedRow.temp,
    };

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`DH Survey row with DhsId ${dhs_id} updated successfully.`);
            return true;
        } else {
            console.error(`Failed to update DH Survey row with DhsId ${dhs_id}:`, response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in updateDHSurveyRow API call:", error);
        return false;
    }
};

export const deleteDHSurveyByDhsid = async (dhs_id: number) => {
    const apiUrl = getApiUrl(`/api/TitelineDHSurvey/DeleteDHSurveyByDhsid/${dhs_id}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            console.log("DH Survey row deleted successfully.");
            return true;
        } else {
            console.error("Failed to delete DH Survey row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteDHSurveyByDhsid API call:", error);
        return false;
    }
};

